import { ClientLogger } from 'bernie-client';
import type { Controller, FetchOptions } from 'bernie-core';
import { codeSplit } from 'bernie-core';
import type { PageData } from 'bernie-http';
import type { PageStore } from 'bernie-plugin-mobx';

import { TRIP_MANAGE_GUESTS_CONTROLLER_INFO } from 'logging/log-events';
import { logDetailedEvent } from 'logging/logger';

import { BASEPATH } from 'constants/basepath';

/**
 * /trips/egti-CCD-454-0F7C/manage-guests?filter=2
 */

export class TripManageGuestsController implements Controller {
  public readonly bundles = [];
  public readonly exact = true;
  public readonly pageId = 'page.Trip.ManageGuests,U,80';
  public readonly path = `${BASEPATH}/trips/:tripViewId([a-z0-z-]+)/manage-guests`;
  public readonly routeName = 'trip-manage-guests';
  public readonly component = codeSplit(
    /* istanbul ignore next */
    () => import(/* webpackChunkName: "trip-manage-guests" */ 'views/trip-manage-guests-view')
  );

  public readonly pageName = 'page.Trip.ManageGuests';
  public readonly clickstreamPageName = 'Trip Manage Guests';

  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      pageId: this.pageId,
      pageName: this.pageName,
      clickstreamPageName: this.clickstreamPageName,
      title: '' // as page title will be set from graph response
    });
  }

  public fetch(options: FetchOptions): Promise<void> {
    const { stores } = options;

    stores.get<PageStore>('page').pageName = this.pageName;
    ClientLogger.setGlobalData('pageName', this.pageName);

    logDetailedEvent(options.logger, TRIP_MANAGE_GUESTS_CONTROLLER_INFO, {
      request: options.request,
      message: 'Request made to trips-manage-guests-controller'
    });

    return Promise.resolve();
  }
}
